import {
  FiLock,
  FiSettings,
  FiRefreshCw,
  FiKey,
  FiShield,
  FiBriefcase,
  FiPhone,
  FiCheckCircle
} from "react-icons/fi";

import { motion } from "framer-motion";
import "./Services.css";


function Services() {


  const services = [

    {
      number:"01",
      title:"Emergency Lockouts",
      text:"Locked out of your home, office, or vehicle? Our emergency locksmiths provide fast 24/7 assistance to get you safely back inside.",
      icon:<FiLock />,
      popular:true
    },

    {
      number:"02",
      title:"Lock Repairs",
      text:"Damaged, broken, or difficult locks repaired professionally to restore your property's security.",
      icon:<FiSettings />
    },

    {
      number:"03",
      title:"Lock Replacement",
      text:"Upgrade old or damaged locks with reliable high-security locking solutions for better protection.",
      icon:<FiRefreshCw />
    },

    {
      number:"04",
      title:"Key Cutting",
      text:"Precision duplicate keys created quickly using professional cutting equipment.",
      icon:<FiKey />
    },

    {
      number:"05",
      title:"Security Upgrades",
      text:"Improve your property's safety with modern locks, security assessments, and protection upgrades.",
      icon:<FiShield />
    },

    {
      number:"06",
      title:"Commercial Locksmith",
      text:"Reliable locksmith solutions for offices, shops, warehouses, and commercial properties.",
      icon:<FiBriefcase />
    }

  ];



  return (

<section className="services" id="services">

<div className="container">


<div className="section-header">

<motion.span
className="section-tag"
initial={{opacity:0,y:20}}
whileInView={{opacity:1,y:0}}
viewport={{once:true}}
>
OUR SERVICES
</motion.span>


<motion.h2
initial={{opacity:0,y:20}}
whileInView={{opacity:1,y:0}}
viewport={{once:true}}
>
Locksmith Solutions You Can Trust
</motion.h2>


<motion.p
initial={{opacity:0}}
whileInView={{opacity:1}}
viewport={{once:true}}
>
Fast, professional locksmith services designed to protect
your home, vehicle, and business whenever you need us.
</motion.p>


</div>




<div className="service-grid">


{
services.map((service,index)=>(

<motion.div

className={`service-card ${service.popular ? "featured":""}`}

key={service.number}


initial={{
opacity:0,
y:40
}}


whileInView={{
opacity:1,
y:0
}}


viewport={{
once:true
}}


transition={{
delay:index * .1
}}

>


{
service.popular &&

<div className="popular">
Most Requested
</div>

}



<div className="service-number">
{service.number}
</div>



<div className="service-icon">

{service.icon}

</div>



<h3>
{service.title}
</h3>



<p>
{service.text}
</p>



<div className="service-check">

<FiCheckCircle/>

Professional Service

</div>



</motion.div>

))

}


</div>





<motion.div

className="services-cta"

initial={{
opacity:0,
y:40
}}

whileInView={{
opacity:1,
y:0
}}

viewport={{
once:true
}}

>


<div>

<h3>
Need a locksmith right now?
</h3>

<p>
Our emergency team is ready 24/7 across Cape Town.
</p>

</div>



<a href="tel:+27604971899">

<FiPhone/>

Call Emergency Locksmith

</a>



</motion.div>




</div>

</section>


  );

}


export default Services;